import { useIsEditForm } from "@/widgets/classic-form/IsEditFormContext";
import { Subscribe } from "@/widgets/classic-form/form";
import type { ClearBtnAttributes } from "@/entities/form-metadata";
import { Clear } from "./Clear";

export const ClearSection = ({ label }: ClearBtnAttributes) => {
    const isEditForm = useIsEditForm();

    return (
        <Subscribe
            selector={({ isDirty, isValid, isSubmitting, values: { treePerson } }) => {
                if (isEditForm) return { disabled: isSubmitting };
                const disabled = treePerson.treeId ? false : !isDirty || !isValid || isSubmitting;

                return { disabled };
            }}
            children={({ disabled }) => <Clear label={label} disabled={disabled} />}
        />
    );
};
